import { PushAdminUsersFilters } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/** Active users with their push devices, for the admin board's left pane. */
export function usePushAdminUsersInfiniteQuery(
  filters: PushAdminUsersFilters,
  options?: { enabled?: boolean },
) {
  return useInfinitePaginated({
    queryKey: notificationKeys.adminUsers(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      notificationApi.listAdminUsers({ ...rest, page }).then((response) => response.data),
    enabled: options?.enabled,
  });
}
